export default __webpack_public_path__ + "static/percko-bg-f04b8c1cfbd954b8c1464fce07509929.png";